import { render, staticRenderFns } from "./introducePageThree.vue?vue&type=template&id=071ad5c0&scoped=true"
import script from "./introducePageThree.vue?vue&type=script&lang=js"
export * from "./introducePageThree.vue?vue&type=script&lang=js"
import style0 from "./introducePageThree.vue?vue&type=style&index=0&id=071ad5c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071ad5c0",
  null
  
)

export default component.exports